import React from "react";
import ContentsList from "./ContentsList.js";
import "./ChatList.css"; // 新しいCSSファイルをインポート

function ChatList({ CLog, openViewer, config }) {

 return (
  <div id="chat_log">
    {CLog.map((item, index) => (
      <div key={index} className="chat-item">
        <p className="chat-label">質問:</p>
        <p className="chat-text">{item.askText}</p>
        <p className="chat-label">回答:</p>
        <p className="chat-text" dangerouslySetInnerHTML={{ __html: item.resText }}></p>
        {item.contentList && item.contentList.length > 0 && (
          <>
            <p className="chat-label">ソース:</p>
            <ContentsList documentsList={item.contentList} openViewer={openViewer} config={config} />
          </>
        )}
      </div>
    ))}
  </div>
 );
}

export default ChatList;